__turbopack_context__.v({
  "area-blurb": "style-module-scss-module__lk9ALq__area-blurb",
  "area-blurb-heading": "style-module-scss-module__lk9ALq__area-blurb-heading",
  "area-guide": "style-module-scss-module__lk9ALq__area-guide",
  "guide-wrapper": "style-module-scss-module__lk9ALq__guide-wrapper",
  "stat-cards-container": "style-module-scss-module__lk9ALq__stat-cards-container",
});
